import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
    ENVIRONMENT_INITIALIZER,
    EnvironmentProviders,
    Provider,
    inject,
} from '@angular/core';
import { responseInterceptor } from './response.interceptor';
import { SnackbarService } from './snackbar.service';

export const provideErrors = (): Array<Provider | EnvironmentProviders> => {
    return [
        provideHttpClient(withInterceptors([responseInterceptor])),
        {
            provide: ENVIRONMENT_INITIALIZER,
            useValue: () => inject(SnackbarService),
            multi: true,
        },
    ];
};
